import React from 'react';
import type { ReportListItem } from '../../store/reportStore';

type Props = {
  registration: Record<string, unknown>;
  list?: ReportListItem[];
};

const RegisteredClasses: React.FC<Props> = ({ registration, list }) => {
  const classesWithCounts = (list ?? [])
    .slice(0, 20)
    .map((group, index) => {
      const raw = registration?.[`klasse${index + 1}`];
      const numeric = typeof raw === 'number' ? raw : Number(raw ?? 0);
      const count = Number.isFinite(numeric) ? numeric : 0;
      return { text: group.text, count };
    })
    .filter((it) => it.count > 0);

  if (classesWithCounts.length === 0) return null;

  return (
    <div className="text-xs mt-2 grid gap-1">
      {classesWithCounts.map((c, i) => (
        <div
          key={i}
          className="flex w-full items-start text-xs justify-between gap-4"
        >
          <div className="flex flex-1 min-w-0 items-start gap-1">
            <div className="w-[5px] h-[5px] bg-gray-300 rounded-full shrink-0 mt-[6px]"></div>
            <span className="break-words">{c.text}</span>
          </div>
          <div className="font-medium shrink-0 whitespace-nowrap">
            {c.count} {c.count === 1 ? 'Team' : 'Teams'}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RegisteredClasses;
